"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var shisell_1 = require("shisell");
var extenders_1 = require("shisell/extenders");
require("shisell/legacy");
var UserBrowser_1 = __importDefault(require("../session/UserBrowser"));
var writers_1 = __importDefault(require("./writers"));
var AggregateWriter_1 = __importDefault(require("./writers/AggregateWriter"));
var rootDispatcher = undefined;
function generateQueryParamAsExtraExtender(sessionQueryParameters, queryParamName, extraName, extenders) {
    if (sessionQueryParameters.get(queryParamName)) {
        extenders.push(extenders_1.withExtra(extraName, sessionQueryParameters.get(queryParamName)));
    }
}
function initialize(options) {
    var _a;
    var writer = new AggregateWriter_1.default(__spreadArrays(writers_1.default(options), (options.analyticsOptions
        ? options.analyticsOptions.additionalWriters
        : [])));
    var userBrowser = UserBrowser_1.default.get();
    var extenders = [
        extenders_1.withFilter(function (dispatcher) {
            dispatcher.ExtraData.Url = window.location.href.split('?')[0];
            dispatcher.ExtraData.Search = window.location.search;
            dispatcher.ExtraData.Referrer = document.referrer;
            return dispatcher;
        }),
        extenders_1.withIdentity('UserBrowserId', userBrowser.UserBrowserId),
        extenders_1.withMeta('IsTest', !options.isProduction),
        extenders_1.withExtra('IsTest', !options.isProduction),
        extenders_1.withExtra('AppName', options.appName),
        extenders_1.withExtra('OsType', userBrowser.Os),
        extenders_1.withExtra('BrowserType', userBrowser.BrowserType),
        extenders_1.withExtra('BrowserVersion', userBrowser.BrowserVersion),
        extenders_1.withExtra('ScreenWidth', window.screen.width),
        extenders_1.withExtra('ScreenHeight', window.screen.height),
        extenders_1.withExtra('DeviceFormFactor', userBrowser.FormFactor),
        extenders_1.withExtra('CookiesEnabled', userBrowser.CookiesEnabled),
        extenders_1.withExtra('Version', options.version),
        extenders_1.withExtra('NavigatorLanguage', navigator.language),
        extenders_1.withExtra('NavigatorAppName', navigator.appName),
        extenders_1.withExtra('NavigatorAppCodeName', navigator.appCodeName),
        extenders_1.withExtra('UserAgent', userBrowser.UserAgent),
    ];
    if (options.partner) {
        extenders.push(extenders_1.withExtra('EnvironmentPartner', options.partner));
        extenders.push(extenders_1.withExtra('CarrierName', options.partner));
    }
    if (userBrowser.sessionQueryParameters) {
        [
            { p: 'cid', e: 'Cid' },
            { p: 'accountId', e: 'AccountIdFromQueryParameter' },
            { p: 'subscriberId', e: 'SubscriberId' },
        ].map(function (_a) {
            var p = _a.p, e = _a.e;
            return generateQueryParamAsExtraExtender(userBrowser.sessionQueryParameters, p, e, extenders);
        });
    }
    rootDispatcher = (_a = shisell_1.createRootDispatcher(writer.write)).extend.apply(_a, extenders);
}
exports.initialize = initialize;
exports.getDispatcher = function () { return rootDispatcher; };
//# sourceMappingURL=index.js.map